import api from '../../api'

import {
    SET_AD_MUNICIPALITIES
} from '../../constants'

const default_state = {
    municipalities: {}
}
const state = default_state

const actions = {
    FETCH_AD_MUNICIPALITIES: ({state, commit, rootState}, data) => {

        // console.log('data.path (fetch_ad_municipalities) ---->')
        // console.log(data.path)
        return api.get({path: data.path})
            .then((res) => {
                // console.log(res)
                commit(SET_AD_MUNICIPALITIES, res)
            })
    }
}

const mutations = {
    [SET_AD_MUNICIPALITIES] (state, data) {
        state.municipalities = data
    }
}

const getters = {
    ad_municipalities: state => {
        return state.municipalities
    }
}

export default {
    state,
    actions,
    mutations,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/ad/ad_municipalities.js